<template>
    <div class="m_container">
        <Header :title="examInfo.organizer" />
        <section class="m_section">
            <div v-if="showMember" class="member_wrap">
                <form-create
                    v-if="!mloading"
                    ref="memberSetting"
                    v-model="fApi"
                    :rule="rule_member"
                    :option="option"
                />
                <ElButton
                    v-if="!mloading"
                    :loading="saveLoading"
                    type="primary"
                    class="submitbtn"
                    @click="submitMember"
                >下一步</ElButton>
            </div>
            <div v-else class="signup_wrap">
                <el-form
                    ref="dataForm"
                    :rules="rules"
                    :model="temp"
                    label-position="right"
                    label-width="85"
                    class="my_form"
                >
                    <el-form-item label="科目" prop="category_id" class="category_wrap">
                        <img src="../../assets/images/star.png" alt="" class="star_img">
                        <el-radio-group v-if="subjectList.length > 0" v-model="temp.subject_id" @change="onChangeSubject">
                            <el-radio v-for="(item,index) in subjectList" :key="index" :label="item.id" border>{{ item.name }}</el-radio>
                        </el-radio-group>
                        <p v-if="!subjectLoading && subjectList.length <=0" class="col_9">请联系管理设置科目</p>
                    </el-form-item>

                    <el-form-item v-loading="levelLoading" label="等级" prop="level_id" class="category_wrap">
                        <img src="../../assets/images/star.png" alt="" class="star_img">
                        <el-radio-group v-if="subjectLevelList.length > 0" v-model="temp.level_id">
                            <el-radio v-for="(item,index) in subjectLevelList" :key="index" :label="item.id" border>{{ item.name }}</el-radio>
                        </el-radio-group>
                        <p v-if="!levelLoading && temp.subject_id && subjectLevelList.length <=0" class="col_9">请联系管理设置科目等级</p>
                    </el-form-item>
                    <el-form-item>
                        <el-button :loading="saveLoading" type="primary" class="submitbtn" @click="saveSignUp">下一步</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </section>
        <TabBar :current-tab="currentTab" />
    </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import mixin from '@/views/tougao/mixin'
import { mapGetters } from 'vuex'
import { getSid, setSid } from '@/utils/cookies'
import { setId, setIsSubmit, setSubjectId, setLevelId, setMemberId } from '@/utils/cookie_confirmExam'
import { signupMemberInfo, saveSignupMember } from '@/api/SignupMembers'
import { subjectList, submitInfo } from '@/api/SignupSubject'
import { subjectLevelList } from '@/api/SignupSubjectLevel'

export default {
    name: 'SignUp',
    components: { Header, TabBar },
    mixins: [mixin],
    data() {
        return {
            sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
            currentTab: 'signUp',
            froms: '',
            mloading: false,
            showMember: true,
            rule_member: [],
            fApi: {},
            option: {
                form: {
                    inline: true,
                    labelPosition: 'right',
                    labelWidth: '100'
                },
                submitBtn: {
                    icon: 'none',
                    show: false
                }
            },
            subjectList: [],
            subjectLevelList: [],
            subjectLoading: true,
            levelLoading: false,
            saveLoading: false,
            rules: {
                subject_id: [
                    { required: true, message: '科目不能为空', trigger: 'blur' }
                ],
                level_id: [
                    { required: true, message: '科目等级不能为空', trigger: 'blur' }
                ]
            },
            temp: {
                id: undefined,
                sid: this.$route.query.sid ? this.$route.query.sid : getSid(),
                subject_id: '',
                level_id: '',
                member_id: ''
            }
        }
    },

    computed: {
        ...mapGetters(['examInfo'])
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            // vm.froms = from.path
            if (to.query.isEdit) {
                vm.froms = from.path
                vm.temp.id = to.query.id ? to.query.id : ''
                vm.temp.subject_id = to.query.subject_id ? to.query.subject_id : ''
                vm.temp.level_id = to.query.level_id ? to.query.level_id : ''
                vm.getSubjectLevelList(vm.temp.subject_id)
            }
        })
    },

    created() {
        if (this.sid) {
            setSid(this.sid)
            this.getMemberInfo()
            this.getSubjectList()
        }
    },

    methods: {
        getMemberInfo() {
            this.mloading = true
            signupMemberInfo({ sid: this.sid }).then(res => {
                this.mloading = false
                if (res.code === 200) {
                    if (res.data.status === 0) { // 第一次进来 显示基本信息  获取基本信息
                        this.rule_member = this.resetFormRules(this.examInfo.member_settings, 'fApi')
                    } else { // 已经有基本信息了
                        this.temp.member_id = res.data.data.id
                        this.showMember = false
                        // this.rule_member = this.resetFormRules(res.data.data.member_settings, 'fApi')
                    }
                }
            }).catch(() => {
                this.mloading = false
            })
        },

        getSubjectList() { // 获取考试科目列表
            this.subjectLoading = true
            subjectList({ sid: this.sid }).then(res => {
                this.subjectLoading = false
                if (res.code === 200) {
                    this.subjectList = res.data
                }
            }).catch(() => {
                this.subjectLoading = false
            })
        },

        getSubjectLevelList(subject_id) { // 考试科目等级列表
            this.levelLoading = true
            subjectLevelList({ subject_id }).then(res => {
                this.levelLoading = false
                if (res.code === 200) {
                    this.subjectLevelList = res.data
                }
            }).catch(() => {
                this.levelLoading = false
            })
        },

        onChangeSubject(e) { // 选择 科目 - 获取科目等级
            this.getSubjectLevelList(e)
        },

        saveSignUp() { // 下一步 : 报名信息 提交
            if (!this.temp.subject_id) {
                this.$message.warning('请选择科目')
                return
            }
            if (!this.temp.level_id) {
                this.$message.warning('请选择科目等级')
                return
            }
            this.$confirm('确认提交', '确认信息正确', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                submitInfo(this.temp).then(res => { // 确认提交
                    if (res.code === 200) {
                        setIsSubmit('1')
                        setId(this.temp.id ? this.temp.id : '')
                        setSubjectId(this.temp.subject_id)
                        setLevelId(this.temp.level_id)
                        setMemberId(this.temp.member_id)

                        this.$router.push({ path: '/confirmExam', query: { sid: this.sid } })
                    }
                    this.saveLoading = false
                }).catch(() => { this.saveLoading = false })
            })
        },

        submitMember() {
            this.fApi.validate((v) => {
                if (!v) {
                    this.$message({
                        message: '请完善必填项',
                        type: 'warning',
                        showClose: true,
                        duration: 2000
                    })
                    return
                }

                const data = {
                    id: this.temp.member_id ? this.temp.member_id : undefined,
                    sid: this.sid,
                    info: '',
                    member_settings: JSON.parse(JSON.stringify(this.rule_member))
                }

                data.member_settings = this.resetCascaderOptions(data.member_settings)

                this.fApi.submit((formData, $f) => {
                    data.info = formData
                })
                console.log('data', data)

                saveSignupMember(data).then(res => {
                    if (res.code === 200) {
                        this.temp.member_id = res.data.member_id
                        this.showMember = false
                    }
                    this.saveLoading = false
                    window.scrollTo(0, 0)
                }).catch(() => { this.saveLoading = false })
            })
        }
    }
}
</script>

<style lang="less" scoped>
.noscroll{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.col_9{
  color: #999!important;
}
.m_container{
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f5f5f5;

  .m_section {
    flex:1;

    .signup_wrap{
      padding: 20px 10px;
    }

    .submitbtn{
      width: 90%;
      margin: 20px auto 0;
      background: var(--bck);
    }
  }
}
.category_wrap /deep/.el-radio__input{
  display: none;
}
.category_wrap /deep/.el-radio__label{
  padding-left: 0;
}
.category_wrap /deep/.el-radio{
  margin-right: 10px;
  margin-bottom: 10px;
}
.category_wrap /deep/.el-radio.is-bordered+.el-radio.is-bordered{
  margin-left: 0
}
.category_wrap /deep/.el-radio.is-bordered{
  padding: 12px 10px 0 10px;
}
</style>
